// semeia-disable-reexport
export function computeCdaiDas28Activity(das28: number): string {
  let msg = "";
  if (das28 > 22) {
    msg = "Activité forte";
  } else {
    if (das28 > 10 && das28 <= 22) {
      msg = "Activité modérée";
    } else {
      if (das28 > 2.8 && das28 <= 10) {
        msg = "Activité faible";
      } else {
        if (das28 <= 2.8) {
          msg = "Rémission clinique";
        }
      }
    }
  }
  return msg;
}

export function computeSdaiDas28Activity(das28: number): string {
  let msg = "";
  if (das28 > 26) {
    msg = "Activité forte";
  } else {
    if (das28 >= 11 && das28 <= 26) {
      msg = "Activité modérée";
    }
    if (das28 < 11) {
      msg = "Activité faible";
    }
  }
  return msg;
}

export function computeCrpOrVsDas28Activity(das28: number): string {
  let msg = "";
  if (das28 > 5.1) {
    msg = "Activité forte";
  } else {
    if (das28 > 3.2 && das28 <= 5.1) {
      msg = "Activité modérée";
    } else {
      if (das28 >= 2.6 && das28 <= 3.2) {
        msg = "Activité faible";
      } else {
        if (das28 < 2.6) {
          msg = "Rémission clinique";
        }
      }
    }
  }
  return msg;
}
